module.exports = {
  API_DOMAIN: 'https://s3.amazonaws.com',

  ENGLISH_ID: 'en-us',
  JAPANESE_ID: 'ja-jp',
  CHINESE_ID: 'zh-cn',

  EXTERNAL_FILE_PATH: 'http://files.trendmicro.com/products/deepsecurity/',
  SUPPORT_URL: 'https://www.trendmicro.com/en_ca/contact.html',

  LTS_VERSION: '20.0',
  FR_VERSION: '12.5',
  FR_RELEASES: ["12 (FR)", "11.3 (FR)"],
  LTS_RELEASE: ["Long Term Support Release 20 (LTS)"],
  EV_RELEASES: ["12.0", "11.0", "10.0", "9.6", "9.5", "9.0"],
  LTS_DISPLAYED_RELEASES: 2,
  FR_DISPLAYED_RELEASES: 1,
};